import { useEffect } from "react";
import { syncSlickSlideInert } from "../../utils/dynamicHomeUtils/syncSlickSlideInert";

/**
 * Keeps react-slick aria-hidden / cloned slides non-focusable via the `inert` attribute.
 * @param {React.RefObject<HTMLElement|null>} containerRef - Ref to the carousel root.
 * @param {unknown} [resyncKey] - Dependency that forces a re-sync (e.g. slide count / current index).
 * @returns {void}
 */
export default function useSlickSlideInert(containerRef, resyncKey) {
  useEffect(() => {
    const root = containerRef?.current;
    if (!root || typeof MutationObserver === "undefined") {
      return undefined;
    }

    /** Syncs inert state for hidden/cloned slick slides. @returns {void} */
    const sync = () => syncSlickSlideInert(root);
    sync();

    const observer = new MutationObserver(sync);
    observer.observe(root, {
      attributes: true,
      subtree: true,
      attributeFilter: ["aria-hidden", "class"],
      childList: true,
    });

    return () => observer.disconnect();
  }, [containerRef, resyncKey]);
}
